import { PropsWithChildren, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useQueryParams } from 'hooks/useQueryParams'

export const RelayRedirect: React.FC<PropsWithChildren<{}>> = ({
  children
}) => {
  const history = useHistory()
  const queryParams = useQueryParams()
  useEffect(() => {
    const relay = queryParams.get('relay')
    if (!relay) {
      return
    }

    // Prefix the relay parameter with the url so it can be parsed as a url
    const relayUrl = new URL(window.location.origin + relay)
    queryParams.delete('relay')
    relayUrl.searchParams.forEach((value, key) => {
      queryParams.append(key, value)
    })
    history.replace({
      pathname: relayUrl.pathname,
      search: queryParams.toString()
    })
  }, [history, queryParams])

  return <>{children}</>
}
